import {Pageable, PageModel} from "@/api/Paging.ts";
import {http} from "@/api/HttpClient.ts";
import {Spell, SpellSummary} from "@/spells/model/Spell.ts";
import type {CharacterClass} from "@/characters/model/CharacterClasses.ts";
import type {SpellSchool} from "@/spells/model/SpellSchools.ts";
import {SpellFormOutput} from "@/spells/SpellSchema.ts";

export interface SpellFilter {
    name?: string;
    level?: number;
    clazz?: CharacterClass;
    school?: SpellSchool;
}

export async function searchSpells(pageable: Pageable, filter: SpellFilter, signal?: AbortSignal): Promise<PageModel<SpellSummary>> {
    const response = await http.get<PageModel<SpellSummary>>("/spells", {
        params: {...pageable, ...filter},
        signal,
    });
    return response.data;
}

export async function getSpell(id: string, signal?: AbortSignal): Promise<Spell> {
    const response = await http.get<Spell>(`/spells/${encodeURIComponent(id)}`, {signal});
    return response.data;
}

export async function saveSpell(spell: SpellFormOutput): Promise<Spell> {
    const response = await http.post<Spell>("/spells", {
        ...spell,
        image: undefined,
        imageId: spell.image?.id,
        materialComponents: spell.materialComponents || null,
    });
    return response.data;
}

export async function deleteSpell(id: string): Promise<void> {
    await http.delete(`/spells/${encodeURIComponent(id)}`);
}
